import { Eye, EyeOff } from 'lucide-react';
import { type ComponentProps, type ReactElement, useState } from 'react';

import { Field } from '@autop/ui/src/field';

/**
 * 비밀번호 칸 — 오른쪽 눈 버튼으로 보기·숨기기를 바꾼다.
 *
 * 처음엔 늘 가린다. 어깨 너머로 보이는 것을 막는 쪽이 기본이고, 보기는 본인이 고른다.
 * 버튼은 `type="button"` 이다 — 폼 안의 button 은 기본이 submit 이라, 빼면 눈을 누를 때
 * 로그인 요청이 나간다. 이름은 누르면 일어날 일로 읽히고(보기/숨기기), 켜짐은 aria-pressed 로 알린다.
 */
export function PasswordField(
  props: Omit<ComponentProps<typeof Field>, 'type' | 'trailing'>,
): ReactElement {
  const [isVisible, setIsVisible] = useState(false);
  const Icon = isVisible ? EyeOff : Eye;

  return (
    <Field
      {...props}
      type={isVisible ? 'text' : 'password'}
      trailing={
        <button
          type="button"
          aria-label={isVisible ? '비밀번호 숨기기' : '비밀번호 보기'}
          aria-pressed={isVisible}
          aria-controls={props.id}
          onClick={() => setIsVisible((current) => !current)}
          className="flex size-8 items-center justify-center rounded-md text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary"
        >
          <Icon aria-hidden className="size-4" />
        </button>
      }
    />
  );
}
